var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 21,
    viewBox: "0 0 45 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0415039,
    y: 0.5,
    width: 44.9173,
    height: 20,
    rx: 10,
    fill: "#172536"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34667 18H6.51959L7.34667 12.1667H4.4519C3.9722 12.1667 3.98047 11.9 4.13762 11.6167C4.29476 11.3333 4.17897 11.55 4.19551 11.5167C5.26244 9.61667 6.86696 6.78333 9.00081 3H9.82789L9.00081 8.83333H11.8956C12.3008 8.83333 12.3587 9.10833 12.2843 9.25833L12.2264 9.38333C8.96773 15.125 7.34667 18 7.34667 18Z",
    fill: "#FDA536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.812 6V15",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 10.5L15.312 10.5",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.355 6.525L40.3632 6.51667L37.2865 3.41667L36.4098 4.3L38.155 6.05833C37.3775 6.35833 36.8234 7.10833 36.8234 8C36.8234 9.15 37.7497 10.0833 38.8911 10.0833C39.1888 10.0833 39.4617 10.0167 39.7181 9.90833V15.9167C39.7181 16.375 39.3459 16.75 38.8911 16.75C38.4362 16.75 38.064 16.375 38.064 15.9167V12.1667C38.064 11.25 37.3196 10.5 36.4098 10.5H35.5828V4.66667C35.5828 3.75 34.8384 3 33.9286 3H28.9662C28.0564 3 27.312 3.75 27.312 4.66667V18H35.5828V11.75H36.8234V15.9167C36.8234 17.0667 37.7497 18 38.8911 18C40.0324 18 40.9587 17.0667 40.9587 15.9167V8C40.9587 7.425 40.7272 6.9 40.355 6.525ZM33.9286 8.83333H28.9662V4.66667H33.9286V8.83333ZM38.8911 8.83333C38.4362 8.83333 38.064 8.45833 38.064 8C38.064 7.54167 38.4362 7.16667 38.8911 7.16667C39.3459 7.16667 39.7181 7.54167 39.7181 8C39.7181 8.45833 39.3459 8.83333 38.8911 8.83333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhev);
export default __webpack_public_path__ + "static/media/PHEV.c728d9bd5ae0e5a53109c5f27d974105.svg";
export { ForwardRef as ReactComponent };